import API from '../../component/Axios'
import { buildMembershipParams } from './membershipFunnelUtils'

export const MEMBERSHIP_FUNNEL_PATH = '/api/v1/admin/analytics/membership-funnel'
const isRecord = value => value !== null && typeof value === 'object' && !Array.isArray(value)
const assertResponse = (data, valid) => {
    if (!valid) throw new Error('멤버십 퍼널 응답 형식이 올바르지 않습니다.')
    return data
}

export const getMembershipMeta = async () => {
    const { data } = await API.get(`${MEMBERSHIP_FUNNEL_PATH}/meta`)
    return assertResponse(data, isRecord(data) && typeof data.registryVersion === 'string'
        && Array.isArray(data.entrySourceOptions) && Array.isArray(data.platformOptions)
        && Array.isArray(data.rangeOptions) && isRecord(data.allOption)
        && Array.isArray(data.availability?.summary) && Array.isArray(data.availability?.orderSegments))
}

export const getMembershipSummary = async query => {
    const { data } = await API.get(`${MEMBERSHIP_FUNNEL_PATH}/summary`, { params: buildMembershipParams(query) })
    return assertResponse(data, isRecord(data?.meta) && isRecord(data?.filter) && isRecord(data?.kpis)
        && Array.isArray(data?.sources) && data.sources.every(row => Array.isArray(row.steps) && Array.isArray(row.promotionIds))
        && isRecord(data?.landing) && Array.isArray(data.landing.plans) && Array.isArray(data?.days))
}

export const getMembershipOrderSegments = async query => {
    const { data } = await API.get(`${MEMBERSHIP_FUNNEL_PATH}/order-segments`, { params: buildMembershipParams(query, true) })
    return assertResponse(data, isRecord(data?.meta) && isRecord(data?.filter) && isRecord(data?.summary)
        && Array.isArray(data?.detailed) && Array.isArray(data?.grouped))
}
